import { Card, CardHeader, Text } from "@fluentui/react-components";
import styled from "styled-components";

import { ReactComponent as Money } from "assets/icons/moneyIcon.svg";

export const StyledCard = styled(Card)<{
  $isSelected?: boolean;
  $canceled: boolean;
  $expired: boolean;
}>`
  width: 100%;
  max-width: 100%;

  border-radius: 16px;
  position: relative;
  padding: 10px 15px;
  gap: 5px;

  box-shadow: 0px 4px 11px 0px #00000017;
`;

export const HeaderContent = styled.div<{ withImage?: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  ${({ withImage }) =>
    withImage &&
    `
    width: inherit;
    position: absolute;
    top:15px;
    left: 15px;
    right: 15px;
  
  `}
`;

export const BenefitImage = styled.img`
  width: 100%;
  cursor: pointer;
  // object-fit: scale-down;
  // object-fit: cover;
  // object-fit: fill;
  // object-fit: cover;
  object-fit: scale-down;
  height: 169px;
  border-radius: 11px;
`;

export const StyledCardHeader = styled(CardHeader)``;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
`;

export const PackageName = styled(Text)`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
`;

export const Desc = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 40px;
`;

export const ActionWrap = styled.div<{ $isAdd?: boolean; $withShadow?: boolean }>`
  display: flex !important;
  justify-content: center;
  align-items: center;

  width: fit-content !important;
  height: fit-content !important;

  border-radius: 5px;
  ${({ $withShadow }) => ($withShadow ? "box-shadow: -1px 2px 2px 0px #00000066;" : "")}

  button {
    min-width: 120px !important;
    padding: 5px 10px !important;
  }
  button:not(:disabled) {
    cursor: pointer;

    background-color: ${({ theme, $isAdd }) =>
      $isAdd ? theme.palette.green : theme.palette.white};
    color: ${({ theme, $isAdd }) => ($isAdd ? theme.palette.green : theme.palette.red)};
    border: 1px solid ${({ theme, $isAdd }) => ($isAdd ? theme.palette.green : theme.palette.red)};
  }
`;

export const CategoryAndPriceWrap = styled.div<{ withImage?: boolean }>`
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: fit-content !important;
  height: fit-content !important;
  cursor: pointer;
  ${({ withImage }) =>
    withImage &&
    `
    justify-content: space-between;
    width: 100% !important;
  
  `}
`;

export const StyledMoneyIcon = styled(Money)<{ withImage?: boolean }>`
  path {
    fill: ${({ theme, withImage }) =>
      withImage ? theme.palette.white : theme.palette.neutralDark};
  }
`;

export const PlaceholderImageBox = styled.div`
  width: 100%;
  height: 169px;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.palette.themeLighterAlt},
    ${({ theme }) => theme.palette.neutralLighter}
  );
  border-radius: 11px;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #6b7280;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.neutralLight};
  transition: box-shadow 0.3s ease;
`;
